/** FAQ, Support, and Advertising page copy (Spanish). */
export const pagesMessagesEs = {
  faq: {
    pageTitle: "Preguntas frecuentes",
    pageSubtitle: "Encuentra respuestas a las preguntas más comunes sobre WasOK",
    seoTitle: "FAQ — WasOK",
    seoDescription:
      "Respuestas a preguntas frecuentes sobre WasOK, el escaneo de productos, la privacidad y las valoraciones.",
    items: [
      {
        question: "¿Cómo funciona WasOK?",
        answer:
          "WasOK te ayuda a recordar qué productos te gustaron o no escaneando los códigos de barras y guardando tus valoraciones y notas. Simplemente escanea el código de barras de un producto, valóralo, añade notas y, la próxima vez que escanees el mismo producto, verás al instante tu opinión anterior.",
      },
      {
        question: "¿Se almacenan mis datos en la nube?",
        answer:
          "¡No! Todos tus datos se almacenan localmente en tu dispositivo. No sincronizamos tu información con la nube, lo que significa que tu historial de compras y tus opiniones sobre productos permanecen completamente privados. Sin embargo, esto también significa que deberías hacer copias de seguridad de tu dispositivo si quieres conservar tus datos.",
      },
      {
        question: "¿Necesito conexión a internet para usar WasOK?",
        answer:
          "No, WasOK funciona completamente sin conexión. Como todos tus datos se almacenan localmente en tu dispositivo, puedes escanear productos, añadir valoraciones y ver tu historial sin necesidad de internet.",
      },
      {
        question: "¿Puedo usar WasOK para cualquier tipo de producto?",
        answer:
          "¡Sí! WasOK funciona con cualquier producto que tenga un código de barras. Ya sea comida, cosméticos, artículos del hogar, electrónica o cualquier otra cosa con código de barras, puedes escanearlo y guardar tu opinión.",
      },
      {
        question: "¿Cómo escaneo un código de barras?",
        answer:
          "Simplemente abre la aplicación WasOK y toca el botón de escaneo. Apunta la cámara al código de barras del producto, y la aplicación lo detectará y escaneará automáticamente. Asegúrate de que el código de barras esté bien iluminado y enfocado para obtener los mejores resultados.",
      },
      {
        question: "¿Puedo añadir fotos a mis reseñas de productos?",
        answer:
          "¡Sí! Puedes adjuntar fotos a cualquier reseña de producto. Esto es especialmente útil para recordar detalles del envase, listas de ingredientes o cualquier otra información visual que pueda ayudarte a recordar por qué te gustó o no un producto.",
      },
      {
        question: "¿Qué información puedo guardar sobre los productos?",
        answer:
          "Puedes guardar valoraciones (de 1 a 5 estrellas), notas de texto, fotos, el precio que pagaste, dónde lo compraste y categorías personalizadas. Esta información completa te ayuda a tomar decisiones informadas al comprar.",
      },
      {
        question: "¿Puedo crear listas de la compra?",
        answer:
          "¡Sí! WasOK te permite crear listas de la compra a partir de productos que ya has valorado. Esto facilita recordar qué productos te encantaron y quieres volver a comprar.",
      },
      {
        question: "¿Cómo organizo mis productos?",
        answer:
          "Puedes organizar los productos usando categorías personalizadas. Por ejemplo, podrías crear categorías como «Snacks», «Café», «Cuidado de la piel» o «Productos de limpieza». Esto facilita explorar tus reseñas por tipo.",
      },
      {
        question: "¿WasOK es gratis?",
        answer:
          "Sí, WasOK es completamente gratuito de descargar y usar. No hay compras dentro de la aplicación, suscripciones ni tarifas ocultas. Creemos que todo el mundo debería tener acceso a una forma privada de recordar sus preferencias de productos.",
      },
      {
        question: "¿WasOK es accesible?",
        answer:
          "WasOK está diseñado para que lo pueda usar el mayor número de personas posible. La aplicación incluye funciones de accesibilidad como compatibilidad con lectores de pantalla, texto escalable y un modo de alto contraste opcional.",
      },
      {
        question: "¿Qué pasa si desinstalo la aplicación?",
        answer:
          "Como todos los datos se almacenan localmente en tu dispositivo, desinstalar la aplicación eliminará todas tus reseñas de productos, notas y listas de la compra. Asegúrate de exportar tus datos antes de desinstalar si quieres conservar una copia de seguridad.",
      },
      {
        question: "¿Puedo exportar mis datos?",
        answer:
          "Sí, WasOK te permite exportar tus datos con fines de copia de seguridad. Puedes exportar todas tus reseñas a un archivo que puedes guardar en tu dispositivo o en el almacenamiento en la nube que prefieras.",
      },
      {
        question: "¿WasOK rastrea mi ubicación?",
        answer:
          "No, WasOK no rastrea tu ubicación. Aunque puedes introducir manualmente el nombre de la tienda donde compraste un producto, la aplicación no utiliza GPS ni servicios de ubicación.",
      },
      {
        question: "¿Puedo usar WasOK en varios dispositivos?",
        answer:
          "Actualmente, WasOK no se sincroniza entre dispositivos, ya que todos los datos se almacenan localmente. Cada dispositivo tendrá su propia base de datos independiente de productos y reseñas.",
      },
      {
        question: "¿Qué pasa si un código de barras no se escanea?",
        answer:
          "Si un código de barras no se escanea, asegúrate de que esté bien iluminado y enfocado. También puedes intentar limpiar la lente de la cámara. Si el código de barras está dañado o poco claro, es posible que puedas introducir manualmente el número de código.",
      },
    ],
    cta: {
      heading: "¿Todavía tienes preguntas?",
      body: "Ponte en contacto con nuestro equipo de soporte: estaremos encantados de ayudarte.",
      button: "Contactar con soporte",
    },
  },
  support: {
    pageTitle: "Soporte",
    seoTitle: "Soporte — WasOK",
    seoDescription:
      "Obtén ayuda con WasOK: contacta con soporte, reporta errores y comparte tu opinión.",
    getHelp: {
      title: "Obtener ayuda",
      body: "Estamos aquí para ayudarte a sacar el máximo partido de WasOK. Si tienes problemas o preguntas, disponemos de varios recursos para ayudarte.",
    },
    faq: {
      title: "Preguntas frecuentes",
      body: "Antes de contactarnos, revisa nuestra sección de preguntas frecuentes, donde respondemos a las dudas más comunes sobre WasOK. Encontrarás información detallada sobre cómo funciona la aplicación, la privacidad, el almacenamiento de datos y más.",
    },
    contact: {
      title: "Contactar con soporte",
      body: "Si no encuentras la respuesta que buscas, nuestro equipo de soporte está listo para ayudarte. Puedes contactarnos en:",
      emailLabel: "Correo electrónico:",
      responseTime: "Normalmente respondemos en un plazo de 24-48 horas",
    },
    bugs: {
      title: "Reportar errores",
      body: "¿Encontraste un error? Agradecemos tu ayuda para mejorar WasOK. Al reportar un error, incluye por favor:",
      items: [
        "Una descripción detallada del problema",
        "Los pasos para reproducir el problema",
        "El modelo de tu dispositivo y la versión de Android",
        "Capturas de pantalla o grabaciones de pantalla si es posible",
      ],
      sendPrefix: "Envía los reportes de errores a:",
    },
    featureRequests: {
      title: "Solicitudes de funciones",
      bodyBefore: "¿Tienes una idea para una nueva función? ¡Nos encantaría saberlo! Envía tus sugerencias a",
      bodyAfter:
        ". Aunque no podemos implementar todas las solicitudes, tenemos en cuenta todos los comentarios al planificar futuras actualizaciones.",
    },
    knownIssues: {
      title: "Problemas conocidos",
      body: "Actualmente conocemos los siguientes problemas y estamos trabajando en solucionarlos:",
      items: [
        "Es posible que algunos códigos de barras no se escaneen con poca luz — prueba a usar una linterna",
        "Las notas de producto muy largas pueden tardar un momento en guardarse en dispositivos más antiguos",
        "Las miniaturas de imágenes pueden verse pixeladas en pantallas de alta resolución",
      ],
    },
    appUpdates: {
      title: "Actualizaciones de la aplicación",
      body: "Publicamos actualizaciones periódicamente con nuevas funciones, mejoras y correcciones de errores. Mantén WasOK actualizado a través de Google Play Store para obtener las últimas mejoras.",
    },
    community: {
      title: "Comunidad",
      body: "Únete a nuestra comunidad de usuarios que toman decisiones de compra más inteligentes con WasOK. Comparte consejos, haz preguntas y conecta con otros usuarios en nuestros canales sociales.",
    },
    emergency: {
      title: "Soporte de emergencia",
      body: 'Si tienes un problema crítico que te impide usar la aplicación, marca tu correo con «URGENT» en el asunto, y priorizaremos tu solicitud.',
    },
    cta: {
      heading: "¿Necesitas más ayuda?",
      body: "Nuestro equipo de soporte está aquí para ti. No dudes en contactarnos con cualquier pregunta o inquietud.",
      button: "Enviar correo a soporte",
    },
  },
  advertising: {
    pageTitle: "Publicidad y monetización",
    seoTitle: "Publicidad — WasOK",
    seoDescription: "Cómo aborda WasOK la publicidad y la monetización.",
    approach: {
      title: "Nuestro enfoque",
      body: "En WasOK, creemos que tus hábitos de compra y opiniones sobre productos son privados y personales. Nuestro modelo de negocio refleja este valor fundamental.",
    },
    noAds: {
      title: "Sin publicidad",
      body: "WasOK no muestra ningún tipo de publicidad. Nunca te mostraremos anuncios basados en los productos que escaneas, las valoraciones que das o cualquier otro dato que crees en la aplicación. Tu experiencia con WasOK está completamente libre de anuncios.",
    },
    noDataSelling: {
      title: "Sin venta de datos",
      body: "No vendemos, alquilamos ni compartimos tus datos con anunciantes, corredores de datos ni terceros. Como todos tus datos se almacenan localmente en tu dispositivo, ni siquiera nosotros tenemos acceso a ellos. Tus reseñas de productos, listas de la compra y notas son solo tuyas.",
    },
    noTracking: {
      title: "Sin rastreo",
      body: "WasOK no utiliza píxeles de rastreo, servicios de análisis ni ninguna otra tecnología que monitoree tu comportamiento o comparta información con terceros. No rastreamos qué productos escaneas, en qué tiendas compras ni cómo usas la aplicación.",
    },
    sustainability: {
      title: "Cómo nos mantenemos sostenibles",
      body: "Puede que te preguntes cómo mantenemos WasOK gratis sin publicidad ni venta de datos. Nuestro enfoque es sencillo:",
      items: [
        {
          label: "Gratis y abierto:",
          text: "WasOK es gratuito para que lo use cualquiera, sin niveles premium ni muros de pago",
        },
        {
          label: "Operación austera:",
          text: "Mantenemos nuestros costes bajos desarrollando software eficiente y centrado en la privacidad",
        },
        {
          label: "Donaciones opcionales:",
          text: "Los usuarios que aman WasOK pueden apoyarnos con donaciones voluntarias",
        },
        {
          label: "Código abierto:",
          text: "Podemos ofrecer servicios de consultoría o desarrollo a medida para organizaciones",
        },
      ],
    },
    noAffiliate: {
      title: "Sin enlaces de afiliados",
      body: "WasOK no utiliza enlaces de afiliados ni recibe comisiones de minoristas. Cuando escaneas un producto, no te redirigimos a ningún sitio para comprarlo. La aplicación está pensada únicamente para tu registro personal y toma de decisiones.",
    },
    noPromotions: {
      title: "Sin promociones de productos",
      body: "No aceptamos pagos de marcas o fabricantes para promocionar sus productos. WasOK nunca te sugerirá productos, destacará ciertas marcas ni influirá en tus valoraciones de ninguna manera. Tus opiniones son solo tuyas.",
    },
    partnerships: {
      title: "Asociaciones con terceros",
      body: "WasOK no se asocia con empresas de marketing, agregadores de datos ni redes publicitarias. Operamos de forma independiente y priorizamos tu privacidad por encima de todo.",
    },
    future: {
      title: "Planes futuros",
      body: "Estamos comprometidos a mantener WasOK libre de anuncios y centrado en la privacidad. Si en el futuro alguna vez necesitáramos introducir un modelo de negocio sostenible, nosotros:",
      items: [
        "Anunciaremos cualquier cambio con suficiente antelación",
        "Nunca comprometeremos la privacidad ni la seguridad de los datos",
        "Siempre ofreceremos una forma de usar la aplicación sin rastreo ni anuncios",
        "Escucharemos los comentarios y preocupaciones de los usuarios",
      ],
    },
    supporting: {
      title: "Apoyar a WasOK",
      body: "Si te encanta WasOK y quieres apoyar nuestra misión de una memoria de compras centrada en la privacidad, puedes:",
      items: [
        "Contarles a tus amigos y familiares sobre la aplicación",
        "Dejar una reseña positiva en Google Play Store",
        "Compartir con nosotros tus comentarios y sugerencias",
        "Considerar hacer una donación voluntaria (cuando esté disponible)",
      ],
    },
    cta: {
      heading: "¿Preguntas sobre nuestras políticas?",
      body: "Somos transparentes sobre cómo funciona WasOK. Si tienes alguna pregunta sobre nuestro enfoque de privacidad, monetización o sostenibilidad, ponte en contacto con nosotros.",
      button: "Contáctanos",
    },
  },
};
